export default 'https://tme.understood.org/assets/outro.en.185a3789.vtt'